import { z } from 'zod';

export const ArchivePartyReasonSchema = z.enum(['CUSTOMER_REQUEST', 'OFFICE_INITIATIVE', 'OTHER']);
export type ArchivePartyReason = z.infer<typeof ArchivePartyReasonSchema>;

export const ArchivePartyBodySchema = z.object({
  archiveReason: ArchivePartyReasonSchema.optional(),
  /** Legacy audit fields — prefer `archiveReason`. Still accepted for API compatibility. */
  lgpdRequestId: z.string().trim().optional(),
  /** Legacy audit fields — prefer `archiveReason`. Still accepted for API compatibility. */
  baseLegal: z.string().trim().optional(),
});

export type ArchivePartyBody = z.infer<typeof ArchivePartyBodySchema>;

export const ArchivePartyResponseSchema = z.object({
  partyId: z.uuid(),
  status: z.literal('ARCHIVED'),
});

export type ArchivePartyResponse = z.infer<typeof ArchivePartyResponseSchema>;
